import { gql } from "@apollo/client";

// TODO FIXME!!!!
// 1. This gets called repeatedly for some reason
// 2. We should never be using the modelPath for queries. Use the
//    model ID and get the model path on the backend.
// 3. We should be getting spend data columns from the ModelDataColumns
//    saved in DM
export const FETCH_SPEND_DATA_COLUMNS = gql`
  query SpendDataColumns($modelPath: String!) {
    me {
      mmm {
        spendDataColumns(modelPath: $modelPath) {
          spendDataColumns {
            prettyName
            id
          }
        }
      }
    }
  }
`;

export const FETCH_FORECAST = gql`
  query Forecast($input: MMMForecastInput!) {
    me {
      mmm {
        forecast(input: $input) {
          prediction {
            date
            kpis
          }
          forecastedContributionsByKpi {
            kpi_name
            contribution_baseline
            contribution_promotion
            contribution_spend
            contribution_spend_times_promo
          }
        }
      }
    }
  }
`;

export const FETCH_CUSTOM_SCENARIO_DATA = gql`
  query FetchCustomScenarioData($cycleId: String!) {
    me {
      mmm {
        customScenarioData(cycleId: $cycleId) {
          id
          cycleId
          name
          createdAt
          updatedAt
          uploader
          isAddedToMix
          data
        }
      }
    }
  }
`;

export const CREATE_MMM_CUSTOM_SCENARIO_DATA = gql`
  mutation CreateMmmCustomScenarioData(
    $cycleId: String!
    $name: String!
    $uploader: String!
    $data: [[JSONObject!]!]!
  ) {
    createMmmCustomScenarioData(
      cycleId: $cycleId
      name: $name
      uploader: $uploader
      data: $data
    ) {
      id
      cycleId
      name
      createdAt
      updatedAt
      uploader
      isAddedToMix
      data
    }
  }
`;

export const UPDATE_MMM_CUSTOM_SCENARIO_DATA = gql`
  mutation UpdateMmmCustomScenarioData(
    $id: String!
    $isAddedToMix: Boolean!
    $name: String!
  ) {
    updateMmmCustomScenarioData(
      id: $id
      isAddedToMix: $isAddedToMix
      name: $name
    ) {
      id
      cycleId
      name
      createdAt
      updatedAt
      uploader
      isAddedToMix
      data
    }
  }
`;

export const DELETE_MMM_CUSTOM_SCENARIO_DATA = gql`
  mutation DeleteMmmCustomScenarioData($id: String!) {
    deleteMmmCustomScenarioData(id: $id) {
      id
      cycleId
      name
      createdAt
      updatedAt
      uploader
      isAddedToMix
      data
    }
  }
`;
